import { Component, Input, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { BookingLoginService } from '../booking-login/booking-login.service';

@Component({
  selector: 'app-tariff',
  templateUrl: './tariff.component.html',
  styleUrls: ['./tariff.component.scss']
})
export class TariffComponent implements OnInit {
  @Input() istariff: boolean = false;

  roomCategories: any[] = [];

  tariffData: any[] = [];

  specialTreatments: any[] = [];

  otherCharges: any[] = [];

  tariffEffectiveFrom: any;

  constructor(private route: ActivatedRoute, private router: Router, public bookingloginService: BookingLoginService,) { }

  section: string = '';
  ngOnInit(): void {
    this.route.url.subscribe(() => {
      this.route.firstChild?.data.subscribe(data => {
        if (data['section']) {
          this.section = data['section'];
        }
        //this.GetRoomCategories();
        this.GetTariff();
      });
    });
  }

  GetRoomCategories() {
    this.bookingloginService.GetRoomCategories().subscribe(
      (response: any) => {
        this.roomCategories = response;
      },
      (error) => {
        console.log(error);
      }
    );
  }

  GetTariff() {

    this.bookingloginService.GetTariff().subscribe(
      (data: any[]) => {

        this.tariffData = data;

        this.roomCategories = data.filter(
          x => x.ChargeType === 'Room'
        );

        this.specialTreatments = data.filter(
          x => x.ChargeType === 'Treatment'
        );

        this.otherCharges = data.filter(
          x => x.ChargeType === 'OtherCharge'
        );

        if (data.length > 0) {
          this.tariffEffectiveFrom = data[0].EffectiveFrom;
        }

      },
      error => {
        console.log(error);
      }
    );

  }
}
